export const textSizes = {
  default: "12px",
  sbHeader: "12px",
  titleSize: "14px",
} as const;

export const textWeights = {
  sbHeader: "500",
} as const;
